import React from 'react'
import { useTranslation } from 'react-i18next'
import { InputLabel } from '@node-space/storybook-components/dist/FormElements'
import { Input, InputProps } from '@node-space/storybook-components/dist/Input'
import { Box } from '@node-space/ui-components'

export interface DynamicContactQuestionProps {
  code: string
  firstNameField: InputProps
  lastNameField: InputProps
  emailField: InputProps
}

export const DynamicContactQuestion = ({
  code,
  firstNameField,
  lastNameField,
  emailField,
}: DynamicContactQuestionProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gap={24}>
      <InputLabel canWrap>{firstNameField?.label}</InputLabel>
      <Box>
        <InputLabel forId={code}>{lastNameField?.label}</InputLabel>
        <Box flex gap={8}>
          <Input {...firstNameField} label="" placeholder={t('firstName')} />
          <Input {...lastNameField} label="" placeholder={t('lastName')} />
        </Box>
      </Box>
      <Input {...emailField} />
    </Box>
  )
}
